import React from 'react'

import { BOOKING_STATUS_LABEL } from 'constants/Booking'

import { COLORS } from '../../constants'
import { BerthCardWithMinutes, CardLayout } from '../../types'
import { getCardTheme } from '../../utils/cardTheme'
import { formatTime } from '../../utils/timeConvert'
import { LoadingAndUnLoadingBadge } from '../LoadingAndUnLoadingBadge'

import styles from './index.module.css'

type Props = {
  card: BerthCardWithMinutes
  layout: CardLayout
  onTap: (cardId: string) => void
}

const getStatusDisplay = (card: BerthCardWithMinutes): string => {
  return BOOKING_STATUS_LABEL[card.status as keyof typeof BOOKING_STATUS_LABEL] || '不明'
}

export const BerthCardComponent: React.FC<Props> = ({ card, layout, onTap }) => {
  const cardTheme = getCardTheme(card.status)
  const isWhiteBg = cardTheme.bgColor === COLORS.white
  const borderColor = isWhiteBg ? cardTheme.color : cardTheme.bgColor
  const statusDisplay = getStatusDisplay(card)

  // card_view_order 項目 (3行×2列: 左列=items[0..2], 右列=items[3..5])
  const [item1, item2, item3, item4, item5, item6] = card.cardViewItems

  return (
    <div
      className={styles.wrapper}
      style={{
        top: layout.top,
        left: `${layout.left}%`,
        width: `${layout.width}%`,
        height: layout.height,
      }}
      onClick={() => onTap(card.id)}
    >
      <div
        className={styles.inner}
        style={{
          color: cardTheme.color,
          background: cardTheme.bgColor,
          borderColor,
        }}
      >
        {/* ===== ヘッダー行: ステータス + 時間帯 + 卸/積バッジ ===== */}
        <div className={styles.headerRow}>
          <span className={styles.statusLabel}>{statusDisplay}</span>
          <span className={styles.timeRange}>
            {formatTime(card.displayStartMin)} - {formatTime(card.displayEndMin)}
          </span>
          <span>
            <LoadingAndUnLoadingBadge
              isUnloadActive={card.cardType === '卸' || card.cardType === '卸積'}
              isLoadActive={card.cardType === '積' || card.cardType === '卸積'}
              color={isWhiteBg ? cardTheme.color : COLORS.white}
              activeTextColor={cardTheme.bgColor}
              size={18}
            />
          </span>
        </div>

        {/* ===== card_view_order: 3行 × 2列レイアウト (PC版準拠) ===== */}
        <div className={styles.itemGrid}>
          <div className={styles.itemRow}>
            <span className={styles.itemCell}>{item1 || 'ー'}</span>
            <span className={styles.itemSep}>/</span>
            <span className={styles.itemCell}>{item4 || 'ー'}</span>
          </div>
          <div className={styles.itemRow}>
            <span className={styles.itemCell}>{item2 || 'ー'}</span>
            <span className={styles.itemSep}>/</span>
            <span className={styles.itemCell}>{item5 || 'ー'}</span>
          </div>
          <div className={styles.itemRow}>
            <span className={styles.itemCell}>{item3 || 'ー'}</span>
            <span className={styles.itemSep}>/</span>
            <span className={styles.itemCell}>{item6 || 'ー'}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
